import { TECHNIQUES, TECHNIQUE_CATEGORIES } from "@/lib/techniquesData";
import { useNavigate } from "react-router-dom";

export default function TechniquesLibrary() {
  const navigate = useNavigate();

  return (
    <div className="p-6 lg:p-8 max-w-6xl">
      <div className="mb-8">
        <h1 className="text-2xl font-display font-bold text-foreground">
          12 BA Techniques
        </h1>
        <p className="text-sm text-muted-foreground font-body mt-1">
          Analysis frameworks for requirements gathering, stakeholder management, and decision-making
        </p>
      </div>

      {TECHNIQUE_CATEGORIES.map((cat) => {
        const techniques = TECHNIQUES.filter((t) => t.category === cat.id);
        if (techniques.length === 0) return null;
        return (
          <div key={cat.id} className="mb-8">
            <h2 className="text-xs font-mono text-muted-foreground uppercase tracking-wider mb-3 flex items-center gap-2">
              <span>{cat.icon}</span> {cat.label}
            </h2>
            <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
              {techniques.map((t) => (
                <button
                  key={t.id}
                  onClick={() => navigate(`/studio/techniques/${t.id}`)}
                  className="group text-left border border-border rounded-md p-4 hover:border-accent transition-colors bg-card animate-fade-in"
                >
                  <h3 className="font-display font-semibold text-card-foreground group-hover:text-accent transition-colors text-sm mb-1">
                    {t.name}
                  </h3>
                  <p className="text-xs text-muted-foreground font-body line-clamp-2">
                    {t.shortDesc}
                  </p>
                  <p className="text-[10px] text-muted-foreground/70 font-mono mt-2 line-clamp-1">
                    When: {t.when}
                  </p>
                </button>
              ))}
            </div>
          </div>
        );
      })}
    </div>
  );
}
